import React from 'react';
import { AlertCircle } from 'lucide-react';
import { BotonCopiar } from '../../../../components/ButtonCopy';
import { procesarMensajeSolicitud } from '../../../../utils/mensajes_utils';

const HeaderSolicitudes = ({ 
  solicitud, 
  usuario, 
  isAdmin, 
  isTutor, 
  isCliente, 
  configuracion,
  handleRegresar, 
  setShowModalCopia 
}) => {
  return (
    <>
      {/* 1. Barra Gris de Navegación: Esta SÍ va de borde a borde */}
      <div className="bg-gray-100 p-4 flex justify-between items-center border-b">
        <div className="flex space-x-3 items-center">
          <button 
            onClick={handleRegresar}
            className="flex items-center text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 px-4 py-2 rounded-md transition-colors font-medium border border-gray-200 hover:border-gray-300"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Volver
          </button>
          
          <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-semibold uppercase">
            {solicitud.Servicio}
          </div>
          <div className="text-sm text-gray-500 font-mono">ID: {solicitud.id}</div>
          
          <div className={`px-2 py-1 rounded-full text-xs font-bold uppercase ${
            isAdmin ? 'bg-purple-100 text-purple-800' : 
            isTutor ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
          }`}>
            {isAdmin ? 'Vista Administrador' : isTutor ? 'Vista Tutor' : 'Vista Cliente'}
          </div>

          {isAdmin && (
            <div className="flex gap-2">
              <button
                onClick={() => setShowModalCopia(true)}
                className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-md hover:bg-purple-700 transition-colors shadow-sm ml-2"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                Copiar Solicitud
              </button>

              <BotonCopiar
                funcionGenerarTexto={() => procesarMensajeSolicitud(solicitud, configuracion)}
                identificador={`solicitud-${solicitud.id}`}
                className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 hover:text-purple-600 transition-all shadow-sm"
                textoCopiar="Copiar mensaje"
              />
            </div>
          )}
        </div>
      </div>

      {/* 2. Sección de Título y Alertas: AQUÍ AGREGAMOS EL PADDING (px-6 pt-6) */}
      <div className="px-6 pt-6 pb-0"> 
        {/* Cambiamos mb-6 por mb-2 para reducir el hueco con lo que sigue */}
        <h1 className="text-2xl font-black text-gray-800 mb-2 uppercase tracking-tight">
          {solicitud.materia}
        </h1>

        {/* Alerta: Agendado - Cambiamos mb-6 por mb-2 */}
        {solicitud.Estado === 'AGENDADO' && (
          <div className="bg-green-50 border-l-4 border-green-500 text-green-800 p-4 mb-2 rounded-r shadow-sm flex items-center gap-3">
            <AlertCircle size={20} /> 
            <span className="font-bold uppercase text-xs">Esta solicitud ya se encuentra agendada</span>
          </div>
        )}

        {/* Alerta: Expirado o No Podemos - Cambiamos mb-6 por mb-2 */}
        {(solicitud.Estado === 'EXPIRADO' || solicitud.Estado === 'NO PODEMOS') && (
          <div className="bg-red-50 border-l-4 border-red-500 text-red-800 p-4 mb-2 rounded-r shadow-sm flex items-center gap-3">
            <AlertCircle size={20} /> 
            <span className="font-bold uppercase text-xs">
              {solicitud.Estado === 'EXPIRADO' ? 'Solicitud Expirada' : 'No podemos realizar esta solicitud'}
            </span>
          </div>
        )}
      </div>
      
    </>
  );
};

export default HeaderSolicitudes;